<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 27.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 196 132" style="enable-background:new 0 0 196 132;" xml:space="preserve">
<path id="Path_250" style="fill:#EAB5BC;" d="M190.3,132H5.7c-3.2,0-5.7-2.6-5.7-5.7l0,0V5.7C0,2.6,2.6,0,5.7,0h184.6
	c3.2,0,5.7,2.6,5.7,5.7v120.5C196,129.4,193.4,132,190.3,132C190.3,132,190.3,132,190.3,132z"/>
<path id="Path_251" style="fill:#D898A3;" d="M196,5.7v120.5c0,3.2-2.6,5.7-5.7,5.7c0,0,0,0,0,0h-7.9c3.2,0,5.7-2.6,5.7-5.7V5.7
	c0-3.2-2.6-5.7-5.7-5.7h7.9C193.4,0,196,2.6,196,5.7L196,5.7z"/>
<path id="Path_252" style="fill:#E5E1E5;" d="M73.6,116.1H18.5c-1.7,0-3.1-1.4-3.1-3.1V41.8c0-1.7,1.4-3.1,3.1-3.1h55.1
	c1.7,0,3.1,1.4,3.1,3.1v71.3C76.7,114.8,75.3,116.1,73.6,116.1z"/>
<path id="Path_253" style="fill:#D7D0D6;" d="M76.7,41.8v71.3c0,1.7-1.4,3.1-3.1,3.1l0,0h-7.4c1.7,0,3.1-1.4,3.1-3.1V41.8
	c0-1.7-1.4-3.1-3.1-3.1h7.4C75.3,38.7,76.7,40.1,76.7,41.8L76.7,41.8z"/>
<path id="Path_254" style="fill:#E5E1E5;" d="M88.8,96.3h84.9c0.6,0,1.1,0.5,1.1,1.1l0,0v17.7c0,0.6-0.5,1.1-1.1,1.1H88.8
	c-0.6,0-1.1-0.5-1.1-1.1l0,0V97.3C87.7,96.8,88.2,96.3,88.8,96.3L88.8,96.3z"/>
<path id="Path_255" style="fill:#D7D0D6;" d="M174.7,97.4v17.7c0,0.6-0.5,1.1-1.1,1.1h-7.9c0.6,0,1.1-0.5,1.1-1.1l0,0V97.4
	c0-0.6-0.5-1.1-1.1-1.1h7.9C174.2,96.3,174.7,96.8,174.7,97.4z"/>
<path id="Path_256" style="fill:#C15B6F;" d="M196,5.7v17.1H0V5.7C0,2.6,2.6,0,5.7,0h184.5C193.4,0,196,2.6,196,5.7L196,5.7z"/>
<path id="Path_257" style="fill:#AA3954;" d="M196,5.7v17.1h-7.9V5.7c0-3.2-2.6-5.7-5.7-5.7h8C193.4,0,196,2.6,196,5.7z"/>
<g id="Group_517" transform="translate(90.773 67.447)">
	<path id="Path_258" style="fill:#E5E1E5;" d="M81.3,19.8H-0.4c-1.5,0-2.7-1.3-2.7-2.9c0-1.5,1.2-2.8,2.7-2.8h81.7
		c1.5,0,2.7,1.3,2.7,2.9C83.9,18.5,82.7,19.7,81.3,19.8z"/>
</g>
<g id="Group_518" transform="translate(90.773 52.687)">
	<path id="Path_259" style="fill:#E5E1E5;" d="M81.3,19.8H-0.4c-1.5,0-2.7-1.3-2.7-2.9c0-1.5,1.2-2.8,2.7-2.8h81.7
		c1.5,0,2.7,1.3,2.7,2.9C83.9,18.5,82.7,19.7,81.3,19.8z"/>
</g>
<g id="Group_519" transform="translate(90.773 37.928)">
	<path id="Path_260" style="fill:#E5E1E5;" d="M39.5,19.8H-0.3c-1.6,0-2.8-1.3-2.8-2.9c0-1.5,1.3-2.8,2.8-2.8h39.7
		c1.6,0,2.9,1.2,2.9,2.8c0,1.6-1.2,2.9-2.8,2.9C39.5,19.8,39.5,19.8,39.5,19.8z"/>
</g>
<g id="Group_520" transform="translate(28.355 48.183)">
	<path id="Path_261" style="display:none;fill:#596C76;" d="M0.7,19.8V40c0,9.4,7.6,17.1,17.1,17.1S34.8,49.5,34.8,40V19.8H0.7z"/>
	<path id="Path_262" style="display:none;fill:#465A61;" d="M34.8,19.8V40c0,9.4-7.6,17.1-17.1,17.1l0,0c-1.3,0-2.6-0.2-3.9-0.5
		c7.7-1.8,13.1-8.7,13.1-16.6V19.8H34.8z"/>
	<path id="Path_263" style="fill:#93A0A5;" d="M35.5,68H0v-4.8c-0.1-9.8,7.8-17.9,17.6-17.9s17.8,7.8,17.9,17.7c0,0.1,0,0.2,0,0.3
		L35.5,68L35.5,68z"/>
	<path id="Path_264" style="fill:#7C888C;" d="M35.5,63.1v4.8h-7.9v-4.8c0-8.3-5.7-15.5-13.8-17.3c1.3-0.3,2.6-0.4,3.9-0.4
		C27.5,45.4,35.5,53.3,35.5,63.1C35.5,63.1,35.5,63.1,35.5,63.1z"/>
	<path id="Path_265" style="fill:#FED2A4;" d="M17.7,51.5c-3,0-5.4-2.4-5.4-5.5c0,0,0,0,0,0V33.4h10.9V46
		C23.2,49,20.7,51.5,17.7,51.5L17.7,51.5z"/>
	<path id="Path_266" style="fill:#FFBD86;" d="M23.2,33.4V46c0,3-2.4,5.5-5.4,5.5c-1,0-1.9-0.2-2.7-0.7c1.7-1,2.7-2.8,2.7-4.7V33.4
		H23.2z"/>
	<path id="Path_267" style="fill:#FED2A4;" d="M17.7,39.7c-8.5,0-15.4-6.9-15.4-15.4l0,0v-6.1l15.4-6.4l15.4,6.4v6.1
		C33.1,32.8,26.2,39.7,17.7,39.7L17.7,39.7z"/>
	<path id="Path_268" style="fill:#FFBD86;" d="M33.1,18.2v6.1c0,8.5-6.9,15.4-15.4,15.4c-1,0-2.1-0.1-3.1-0.3
		c7.2-1.5,12.3-7.8,12.3-15.1v-8.7L33.1,18.2z"/>
	<path id="Path_269" style="fill:#756559;" d="M33.1,9.7c-4-8.5-14.2-12.1-22.7-8.1C6.9,3.3,4,6.2,2.3,9.7c-1.1,2.5-1.7,5.2-1.7,7.9
		V26c7.1-0.6,13.4-4.5,17.1-10.6c3.6,6.1,10,10,17.1,10.6v-8.4C34.8,14.9,34.2,12.2,33.1,9.7z"/>
	<path id="Path_270" style="fill:#60534A;" d="M34.8,17.6V26c-2.7-0.2-5.4-0.9-7.9-2.2v-6.2c0-2.7-0.5-5.4-1.7-7.9
		C23,5,18.8,1.6,13.8,0.5c7.8-1.9,15.9,2,19.3,9.3C34.2,12.2,34.8,14.9,34.8,17.6z"/>
</g>
<g>
	<circle style="fill:#C15B6F;" cx="161" cy="44.8" r="16.7"/>
	<path style="fill:#E5E1E5;" d="M169.5,42.5l-1.4-4.7c-0.3-1.1-1.3-1.8-2.4-1.8h-9.4c-1.1,0-2.1,0.7-2.4,1.8l-1.4,4.7
		c-0.9,0.4-1.5,1.3-1.5,2.3v5c0,0.7,0.6,1.2,1.2,1.2l0,0v1.2c0,0.7,0.6,1.2,1.2,1.2h1.2c0.7,0,1.2-0.6,1.2-1.2V51h10v1.2
		c0,0.7,0.6,1.2,1.2,1.2h1.2c0.7,0,1.2-0.6,1.2-1.2V51l0,0l0,0c0.7,0,1.2-0.6,1.2-1.2v-5C171,43.7,170.4,42.8,169.5,42.5L169.5,42.5
		z M156.3,38.5h9.4l1.1,3.7h-11.6L156.3,38.5L156.3,38.5z M156,47.9c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2
		S156.7,47.9,156,47.9z M166,47.9c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2S166.7,47.9,166,47.9z"/>
</g>
</svg>
